import { Component, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, ViewChild, AfterViewInit } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { Location } from "@angular/common";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { ChangePasswordService } from "./changepassword.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { MatInput } from "@angular/material";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { FormHelperService } from "../../services/formHelper.service";
import { FormGroup, NgForm } from "@angular/forms";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { Router } from "@angular/router";

@Component({
  selector: "changePassword",
  templateUrl: "./changePassword.component.html",
  styleUrls: ["./changePassword.component.scss"],
  providers: [ChangePasswordService, FormHelperService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePasswordComponent implements OnInit, OnDestroy, AfterViewInit {

  public oldPassword: string = "";
  public newPassword: string = "";
  public confirmPassword: string = "";
  public oldPasswordVisibility: boolean = false; // used for show and hide old password
  public newPasswordVisibility: boolean = false; // used for show and hide new password
  public confirmPasswordVisibility: boolean = false; // used for show and hide confirme password

  private _changePasswordFormSubscriber: Subscription;
  private langSubscriber: Subscription;
  public isSmallView: boolean = false;


  @ViewChild("changePasswordForm", { read: NgForm }) changePasswordForm: NgForm;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _location: Location
    , private _changePasswordService: ChangePasswordService
    , private _snackBarService: SnackBarService
    , private internationalisationService: InternationalisationService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _formHelperService: FormHelperService
    , private _iosHelperService: IOSHelperService
    , private _router: Router
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("ForgetPasswordComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngAfterViewInit(): void {
    const me = this;
    setTimeout(() => {
      me._changePasswordFormSubscriber = me.changePasswordForm.valueChanges.subscribe(() => {
        me.changePasswordForm.form.markAsTouched();
      })
    }, 300);
  }

  ngOnInit() {
    const me = this;
    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me.PushChanges();
  }

  public changePassword(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._changePasswordService.changePassword(me.oldPassword, me.newPassword)
      .then((response) => {
        if (response) {
          me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
          me._router.navigate(["/userprofile"]);
        } else {
          me._snackBarService.ShowErrorMessageFailed(13);
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(14);
      });
  }

  /**show all validation message by clicking on desabled button */
  public showValidationMessage(formGroup: FormGroup): void {
    const me = this;
    me._formHelperService.showValidationMsg(formGroup);
    me.PushChanges();
  }

  public handleEnterKeyup(event) {
    if (event.keyCode === 13) {
      document.getElementById("changePasswordButtonContainer").getElementsByTagName("a")[0].click();
    }
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  public navigateBack(): void {
    const me = this;
    me._location.back();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me._changePasswordFormSubscriber) {
      me._changePasswordFormSubscriber.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }

}
